import { render, staticRenderFns } from "./signInSet.vue?vue&type=template&id=36852b94&scoped=true&"
import script from "./signInSet.vue?vue&type=script&lang=js&"
export * from "./signInSet.vue?vue&type=script&lang=js&"
import style0 from "./signInSet.vue?vue&type=style&index=0&id=36852b94&prod&lang=less&scoped=true&"
import style1 from "./signInSet.vue?vue&type=style&index=1&id=36852b94&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36852b94",
  null
  
)

export default component.exports